import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ colors }: Theme) => createStyles({
  root: {
    marginBottom: 15,
    marginTop: 30,
  },

  text: {
    textAlign: 'left',
    fontFamily: '"Roboto", "Medium"',
    fontSize: 16,
    color: '#2D3950',
    fontWeight: 500,
  },
  icon: {
    fontSize: 14,
    color: colors.icon,
    verticalAlign: 'middle',
    marginBottom: 4,
    marginLeft: 8,
  },
  commentButtonWrapper: {
    textAlign: 'center',
  },
  comment: {
    fontSize: '12px',
    padding: '0 10px 0 10px',
  },
}), { name: 'StepModalCaption' });

export default useStyles;
